import React from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import Routes from './routes';
import { ToastContainer } from 'react-toastify';
import HttpsRedirect from 'react-https-redirect';
import { PersistGate } from 'redux-persist/integration/react';

import './config/ReactotronConfig';

import history from './services/history';
import { store, persistor } from '~/store';

import GlobalStyle from './styles/global';

export default function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <HttpsRedirect>
          <Router history={history}>
            <GlobalStyle />
            <Routes />
            <ToastContainer autoClose={3000} />
          </Router>
        </HttpsRedirect>
      </PersistGate>
    </Provider>
  );
}
